// extracted by mini-css-extract-plugin
module.exports = {"tagCertificateListWrapper":"styles_tagCertificateListWrapper__StS32","tagListWrapperNoTags":"styles_tagListWrapperNoTags__3RVC5"};